/** 密码最小长度 */
export const PASSWORD_MIN_LENGTH = 8;

/** 密码复杂度提示（用于 placeholder、表单项说明等） */
export const PASSWORD_COMPLEXITY_HINT =
  '至少8位，且包含大写字母、小写字母、数字、特殊符号中的至少3种';

/** 密码复杂度校验失败时的完整错误文案 */
export const PASSWORD_COMPLEXITY_ERROR_MESSAGE = `密码须${PASSWORD_COMPLEXITY_HINT}`;

/** 统计密码包含的字符类型数量（大写、小写、数字、特殊符号） */
export function countPasswordCharacterTypes(password: string): number {
  let types = 0;
  if (/[A-Z]/.test(password)) types += 1;
  if (/[a-z]/.test(password)) types += 1;
  if (/\d/.test(password)) types += 1;
  if (/[^A-Za-z0-9]/.test(password)) types += 1;
  return types;
}

/** 是否满足：至少 8 位，且四类字符中至少包含 3 类 */
export function isPasswordMeetingComplexityRules(password: string): boolean {
  if (!password || password.length < PASSWORD_MIN_LENGTH) {
    return false;
  }
  return countPasswordCharacterTypes(password) >= 3;
}

/** Ant Design Form 密码复杂度校验（空值跳过，供可选改密场景） */
export function validatePasswordComplexity(_: unknown, value: string): Promise<void> {
  if (!value) {
    return Promise.resolve();
  }
  if (value.length < PASSWORD_MIN_LENGTH) {
    return Promise.reject(new Error(`密码长度不能少于${PASSWORD_MIN_LENGTH}位`));
  }
  if (countPasswordCharacterTypes(value) < 3) {
    return Promise.reject(new Error(PASSWORD_COMPLEXITY_ERROR_MESSAGE));
  }
  return Promise.resolve();
}

/** 必填新密码/初始密码规则 */
export const requiredPasswordRules = [
  { required: true, message: '请输入密码' },
  { validator: validatePasswordComplexity },
];

/** 必填新密码（文案为「新密码」） */
export const requiredNewPasswordRules = [
  { required: true, message: '请输入新密码' },
  { validator: validatePasswordComplexity },
];

/** 可选新密码（个人设置等：有值才校验） */
export const optionalNewPasswordRules = [{ validator: validatePasswordComplexity }];

export const NEW_PASSWORD_SAME_AS_OLD_MESSAGE = '新密码不能与当前密码相同';

/** 新密码不得与旧密码相同（Ant Design Form，旧密码字段名可配置） */
export function createValidateNewPasswordNotSameAsOld(oldPasswordField = 'oldPassword') {
  return ({ getFieldValue }: { getFieldValue: (name: string) => string }) => ({
    validator(_: unknown, value: string) {
      if (!value) {
        return Promise.resolve();
      }
      const oldPassword = getFieldValue(oldPasswordField);
      if (oldPassword && value === oldPassword) {
        return Promise.reject(new Error(NEW_PASSWORD_SAME_AS_OLD_MESSAGE));
      }
      return Promise.resolve();
    },
  });
}

/** 必填新密码 + 复杂度 + 不得与当前密码相同 */
export const requiredNewPasswordRulesWithOldCheck = [
  ...requiredNewPasswordRules,
  createValidateNewPasswordNotSameAsOld(),
];

/** 可选新密码 + 复杂度 + 不得与当前密码相同 */
export const optionalNewPasswordRulesWithOldCheck = [
  ...optionalNewPasswordRules,
  createValidateNewPasswordNotSameAsOld(),
];

